import React from "react";
import { Globe } from "lucide-react";

export default function CTraderWebTerminal() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center text-slate-300 bg-slate-950">
      <Globe className="w-6 h-6 text-cyan-400 mb-3" />
      <h2 className="text-lg font-semibold mb-1">cTrader Integration</h2>
      <p className="text-sm text-slate-400 max-w-sm mb-4">
        Direct web access to cTrader terminals is temporarily unavailable
        from external sites due to Spotware DNS restrictions.
        <br />
        You can still access your broker’s platform below.
      </p>

      <div className="flex flex-col gap-2">
        <a
          href="https://www.icmarkets.com/en/trading-platform/ctrader"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-cyan-600 hover:bg-cyan-700 text-white text-xs font-semibold px-4 py-2 rounded-md transition"
        >
          🔗 Open IC Markets cTrader
        </a>
        <a
          href="https://www.fxpro.com/trading-platforms/ctrader"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-4 py-2 rounded-md transition"
        >
          🔗 Open FxPro cTrader
        </a>
        <a
          href="https://www.pepperstone.com/en/trading-platforms/ctrader"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold px-4 py-2 rounded-md transition"
        >
          🔗 Open Pepperstone cTrader
        </a>
      </div>

      <p className="text-xs text-slate-500 mt-6">
        Coming soon: Secure cTrader API integration inside M2T.
      </p>
    </div>
  );
}
